import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: any): string {
    return typeof value === 'string' ? value.replace(/<\/?[^>]+(>|$)/g, '') : '';
  }
}
